import { TitlePage } from '../TitlePage/TitlePage';
import { TableWithoutData } from '../TableWithoutData/TableWithoutData';
import { MoonLoader } from 'react-spinners';
import './TableInfo.scss';

const TableInfo = ({
  data,
  title,
  height,
  loading
}) => {
  return (
    <div className="table-info"
      style={{
        minHeight: height ? height : ''
      }}
    >
      {title && <TitlePage
        medium
        title={title}
      />}
      {loading ?
        <div className="table-info__loading">
          <MoonLoader
            color="#7b7b7b"
            speedMultiplier={0.5}
          />
        </div>
        :
        data?.data?.length > 0 ?
          <div className="table-info__content">
            < table className='table-info__table' >
              <thead>
                <tr className="table-info__header-tr">
                  {data?.header?.map((item, ind) => {
                    return (
                      <td key={item + ind} className="table-info__header-td">
                        <p className="table-info__header-td-text">{item}</p>
                      </td>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((item, ind) => {
                  return (
                    <tr key={item + ind}>
                      {item?.map((data_row, index_row) => {

                        let text = data_row
                        let customStyle = {}

                        if (Array.isArray(data_row) && typeof data_row?.[1] == 'object') {
                          text = data_row[0]
                          customStyle = data_row[1]
                        }

                        return (
                          <td key={text + ind}
                            style={{ ...customStyle }}
                            className="table-info__td">
                            <p className="table-info__text"
                              style={{ ...customStyle }}
                            >{text}</p>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          :
          <div className="table-info__no-data">
            <TableWithoutData
              text='Выберите параметры для загрузки данных таблицы'
              maxHeight='140px'
            />
          </div>
      }
    </div >
  );
};

export { TableInfo };
